// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1eP1t","icon":"_1MLi6","spinning":"_25mSG","spin":"ZoP1j","hasClick":"_3Iz8x"};


//////////////////
// WEBPACK FOOTER
// ../src/components/Icon/Icon.css
// module id = 245
// module chunks = 0